export default __webpack_public_path__ + "static/media/character-seal-happy.daf9b7bf.png";